module.exports = __webpack_public_path__ + "media/images/application/template/cc-home-bkg-960px-dark-theme-6716cf2b37ed86749bbdb75a7b9cd246.jpg";